'use client'

import React from 'react'
import { AdvertisingModalEmbedded } from '@/AdvertisingModal/AdvertisingModalEmbedded'

// Newsletter embedded configuration
const newsletterContent = {
  title: 'Get 16 killer tricks for free!',
  introHtml:
    '<p class="text-xl">Sign up for our newsletter and get 16 killer magic tricks that are easy to do. Start learning magic today.</p>',
  imageUrl: 'https://vinc.gumlet.io/pics/free-magic-signup-andi.jpg',
  imageAlt: 'Newsletter signup',
  submitButtonText: 'Send my free tricks!',
}

const newsletterConfig = {
  layout: 'side-by-side' as const,
  maxWidth: 'lg' as const,
  enableCaptcha: true,
  showOnce: false,
  hideForLoggedInUsers: true,
  showFormForLoggedInUsers: false,
}

export const NewsletterEmbed = () => {
  return (
    <AdvertisingModalEmbedded
      content={newsletterContent}
      trackingEventName="Newsletter signup"
      config={newsletterConfig}
    />
  )
}
